import React from "react";
import { SortableItem } from "react-easy-sort";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import HelpIcon from "@material-ui/icons/Help";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import IconButton from "@material-ui/core/IconButton";
import Portlet from "components/Portlet";
import PortletHeader from "components/PortletHeader";
import PortletLabel from "components/PortletLabel";
import PortletContent from "components/PortletContent";
import estadoOperativo from "../../images/estadoOperativo.png";
import vistaRapida from "../../images/vistaRapida.png";
import estadoGeneral from "../../images/estadoGeneral.png";
import vistaRapidaFull from "../../images/vistaRapidaFull.png";
import vistaRapidaCompacta from "../../images/vistaRapidaCompacta.png";
import semaforo from "../../images/semaforo.png";
import comparacionObjetivos from "../../images/comparacionObjetivos.png";
import apdex from "../../images/apdex.png";
import Popover from "@material-ui/core/Popover";
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import { getRouteObject } from "../../utils/fns/get-query-params";

/**
 * @property {string} id - Identificador de la card
 * @property {string} name - Título en la card
 * @property {Boolean} enabled - Card está visible
 * @property {Object} key - key de la card
 * @property {Object} link - Url de redirección de la card
 * @property {Boolean} modal - Mostrar modal de ayuda
 * @property {Object[]} items - Opciones de cambio de card
 * @property {Object} classes - Clases de estilo
 * @property {Boolean} isMoreExpand
 * @property {Boolean} showIsMoreExpand
 * @property {function} handleMore
 * @property {function} handleOpenNew
 * @property {function} handleClose
 * @property {function} handleCloseMore
 * @property {function} handleAdd
 *
 * Board card componente para vista "Tableros"
 * @param {*} props - Propiedades visuales del componente
 * @returns React-Component
 *
 * @author David Maldonado
 * @version 1.0.0
 */

export const BoardCard = ({
  id,
  name,
  enabled,
  keyTwo: key,
  link,
  modal,
  items,
  classes,
  isMoreExpand,
  showIsMoreExpand,
  handleMore,
  handleOpenNew,
  handleClose,
  handleCloseMore,
  handleAdd,
}) => {
  const { t } = useTranslation();
  const windowWidth = window.innerWidth;
  const source =
    id === 0
      ? estadoOperativo
      : id === 1
      ? vistaRapida
      : id === 2
      ? estadoGeneral
      : id === 3
      ? vistaRapidaFull
      : id === 4
      ? vistaRapidaCompacta
      : id === 5
      ? semaforo
      : id === 6
      ? comparacionObjetivos
      : id === 7
      ? apdex
      : "";

  return (
    <SortableItem>
      <div>
        <Portlet
          className={classes.item}
          style={{ boxShadow: "2px 2px 7px 0" }}
        >
          <PortletHeader>
            <PortletLabel title={enabled ? name : ""} />
            <div style={{ display: "flex" }}>
              <IconButton onClick={enabled ? modal : null}>
                <HelpIcon style={{ color: "#b9b9b9" }} />
              </IconButton>
              <IconButton
                key="more"
                aria-label={t('fav-boards.aria.more')}
                id={key}
                onClick={handleMore}
              >
                <MoreVertIcon />
              </IconButton>
              <NavLink to={getRouteObject(link)}>
                <IconButton onClick={handleOpenNew}>
                  <OpenInNewIcon />
                </IconButton>
              </NavLink>
              <IconButton
                key="close"
                aria-label={t('fav-boards.aria.close')}
                onClick={handleClose(key)}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </PortletHeader>
          <PortletContent style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                left: 0,
                top: 0,
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h1"
                style={{
                  color: "#9c9c9c",
                  fontSize: windowWidth < 1200 ? "40px" : "60px",
                  opacity: "0.6",
                  transform: "rotate(-45deg)",
                }}
              >
                {t('fav-boards.card.placeholder.referential')}
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {enabled ? (
                <img className={classes.containerImg} src={source} alt={name} />
              ) : (
                ""
              )}
            </div>
          </PortletContent>
        </Portlet>
        {/* muestra la informacion para cambiar de tablero*/}
        <Popover
          anchorEl={isMoreExpand}
          open={showIsMoreExpand}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handleCloseMore}
        >
          <Typography
            style={{ fontSize: 16, fontWeight: "bold", padding: "10px" }}
            color="text.secondary"
          >
            {t('fav-boards.replace.title')}
          </Typography>
          {items.map(({ name, enabled, key: keyTwo }) =>
            enabled ? null : (
              <List component="div">
                <ListItem component="div">
                  <Button onClick={handleAdd(keyTwo)}>{name}</Button>
                </ListItem>
              </List>
            )
          )}
        </Popover>
      </div>
    </SortableItem>
  );
};
